<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <div class="row">
                <div class="col-12">
                  <h4 class="card-title">Mail Kuyrukları</h4>
                  <p class="card-category">Gönderilen mailler ve gönderilmeyi bekleyen kuyrukları görüntüleyin.</p>
                </div>
              </div>

            </template>


            <table class="table table-hover table-striped">
              <thead>
                <slot name="columns">
                  <tr>
                    <th v-for="column in tableColumns" :key="column">{{ column }}</th>
                  </tr>
                </slot>
              </thead>
              <tbody>
                <tr v-for="(item) in tableData" :key="item._id">
                  <slot :row="item">
                    <td>{{ item.title }}</td>
                    <td>{{ item.fromMailId.mail }}</td>
                    <td>{{ item.mailTemplateId.title }}</td>
                    <td>{{ new Date(item.createdAt).toLocaleString('de') }}</td>
                    <td>{{ item.receiversLength }}</td>
                    <td>{{ item.pendingCount }}</td>
                    <td>{{ item.sendedCount }}</td>
                    <td>{{ item.errorCount }}</td>
                    <td>{{ convertStatus(item.status) }}</td>
                    <td>{{ item.openedCount }}</td>
                    <td>
                      <button @click="downloadReport(item._id); item.clicked = true"
                        :class="['btn btn-sm', item.clicked ? 'btn-success' : 'btn-primary']">

                        <strong style="color: black;">
                          {{ downloadStatus[item._id] ? downloadStatus[item._id] : 'Rapor İndir' }}

                        </strong>
                      </button>
                    </td>
                  </slot>
                </tr>
              </tbody>
            </table>
            <nav aria-label="...">
              <ul class="pagination text-center" style="margin-left: 45%;">

                <li class="page-item"
                  v-for="i of (pagination.totalPages > 1 ? Array.from(Array(pagination.totalPages).keys()).slice(pagination.currentPage > 3 ? pagination.currentPage - 3 : 0, pagination.currentPage + pagination.layOutMax) : [0])"
                  :class="pagination.currentPage == i + 1 ? 'active' : ''" @click="paginationGet(i + 1)"><a
                    class="page-link">{{ i + 1 }}</a></li>



              </ul>
            </nav>
          </card>


        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";

const tableColumns = ['Kuyruk Ismı', 'Gönderen Mail', 'Mail Taslak İsmi', 'Oluşturma Tarihi', 'Toplam Alıcı', 'Beklemede', 'Gönderildi', 'Hata', 'Durum', 'Okundu', 'Rapor İndir']
export default {
  components: {
    Card
  },
  data() {
    return {
      tableColumns,
      tableData: [],
      pagination: {
        currentPage: 1,
        totalPages: 0,
        itemsPerPage: 10,
        layOutMax: 3
      },
      downloadStatus: { "test": "test" }
    }
  },
  mounted() {
    this.getMailQueues();
  },
  methods: {
    paginationGet(i) {
      this.pagination.currentPage = Number(i);
      this.getMailQueues();
      window.scroll({ top: 0, behavior: "smooth" })
    },
    getMailQueues() {
      let q = {};
      let p = {};
      let o = { skip: (this.pagination.currentPage - 1) * this.pagination.itemsPerPage, limit: this.pagination.itemsPerPage, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('mailqueue', query).then((res) => {
        if (res.success == true) {
          this.tableData = res.mailQueues;
          this.pagination.totalPages = Math.ceil(res.count / this.pagination.itemsPerPage);

        } else {

          console.log('error');
        }
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
    convertStatus(status) {
      switch (status) {
        case "pending":
          return 'Beklemede'

        case "running":
          return 'Devam ediyor'

        case "ended":
          return 'Tamamlandı'

        default:
          return '-';
      }
    },
    downloadReport(id) {
      CollectionService.getCollectionItemWithId('mailqueue/report', id).then((res) => {
        if (res.success == true) {
          const filePath = res.filePath;

          const link = document.createElement('a');
          link.href = filePath;
          link.setAttribute('download', filePath);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.log('error');
        }
      })
    }
  }
}
</script>
<style></style>